import React from 'react'
import { ReadinessChecklist, Well } from '@pushly/aqe/lib/components'
import { getClassNames } from '../../../_utils/classnames'
import { Readiness } from '../readiness'

type AppMessageReadinessPanelProps = {
    readiness: Readiness
    /** Verb for the action being unblocked — "Schedule" for a message, "Save" for a template. */
    actionName: string
    loading?: boolean
}

/**
 * What is still standing between this form and its submit button. Pairs with
 * the footer, which shows the same count: a disabled button that cannot say why
 * is the thing this replaces.
 */
export const AppMessageReadinessPanel = ({ readiness, actionName, loading }: AppMessageReadinessPanelProps) => (
    <Well
        title={`Ready to ${actionName}`}
        className={getClassNames('app-message-readiness-panel', 'nested')}
        footerMode="hidden"
    >
        <ReadinessChecklist
            loading={loading}
            items={readiness.checks.map((check) => ({
                key: check.key,
                label: check.label,
                satisfied: check.satisfied,
            }))}
            readyText={`Everything required is set. This app message is ready to ${actionName.toLowerCase()}.`}
        />
    </Well>
)
